import { postData, getData } from "../api/api";

export type ForecastPlanStep = {
  id?: string;
  description?: string;
  kind?: string;
  detail?: string;
};

export type ForecastAnalysisPlan = {
  id?: string;
  status?: string;
  intent?: string;
  method?: string;
  summary?: string;
  kvkkNotice?: string;
  indexName?: string;
  /** Warehouse plans: semantic metric of an adaptor instead of an OpenSearch index. */
  adaptorId?: string;
  adaptorName?: string;
  semanticMetric?: string;
  timeField?: string;
  sampleSize?: number;
  lastError?: string;
  searchType?: string;
  metricAggregation?: string;
  metricField?: string;
  interval?: string;
  historyWindow?: string;
  historyBuckets?: number;
  horizonBuckets?: number;
  steps?: ForecastPlanStep[];
  correlationId?: string;
  kvkkConsentGiven?: boolean;
  aiNarrative?: string;
  analysisPayload?: Record<string, unknown>;
  errorMessage?: string;
};

type ForecastEnvelope = {
  type?: string;
  message?: string;
  forecastPlan?: ForecastAnalysisPlan;
  result?: { forecastPlan?: ForecastAnalysisPlan };
};

function unwrapPlan(body: unknown): ForecastAnalysisPlan {
  const env = body as ForecastEnvelope;
  return env.forecastPlan || env.result?.forecastPlan || (body as ForecastAnalysisPlan);
}

export const forecastPlanService = {
  get: async (id: string) => unwrapPlan(await getData(`/api/chat/forecast-plans/${id}`)),
  approve: async (id: string) =>
    unwrapPlan(await postData(`/api/chat/forecast-plans/${id}/approve`, {})),
  reject: async (id: string) =>
    unwrapPlan(await postData(`/api/chat/forecast-plans/${id}/reject`, {})),
};
